module.exports = __webpack_public_path__ + "static/media/reedhima-mandlik.6d401bfc.jpg";